import { ProductStatus } from 'src/lib/types/common/catalogue'

const statusConfig = {
  ACTIVE: { label: 'Active', className: 'bg-emerald-500/10 text-emerald-800' },
  DRAFT: { label: 'Draft', className: 'bg-yellow-600/10 text-yellow-600' },
  ARCHIVED: { label: 'Archived', className: 'bg-zinc-500/10 text-zinc-500' },
  SUSPENDED: { label: 'Suspended', className: 'bg-red-600/10 text-red-600' },
  UNLISTED: { label: 'Unlisted', className: 'bg-zinc-500/10 text-zinc-500' }
} satisfies Record<ProductStatus, { label: string; className: string }>

export const ProductStatusTag = ({ status }: { status: ProductStatus }) => {
  const config = statusConfig[status]
  if (!config) return null
  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 rounded-md text-text-xxs-medium ${config.className}`}>
      {config.label}
    </span>
  )
}
